import { ModalTitleContainer } from 'screens/Campaigns/components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalTitleContainer'
import { Form, Formik } from 'formik'
import Styles from './CreateBatch.module.scss'
import { StartDateField } from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/CreateBatch/StartDateField'
import { TopicsField } from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/CreateBatch/TopicsField'
import { ModalSubmitContainer } from 'screens/Campaigns/components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalSubmitContainer'
import { Button } from 'blaze-ui/Button'
import { CreateBatchProps } from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/CreateBatch/Types'
import { SourcesField } from 'screens/Campaigns/components/RegenerateCampaignsModal/RegenerateCampaigns/SourcesField'
import { MediaField } from 'screens/Campaigns/components/RegenerateCampaignsModal/RegenerateCampaigns/MediaField'

export const CreateBatch = ({ numberOfCampaigns, startDate, topics, onSubmit }: CreateBatchProps) => {
  return (
    <>
      <ModalTitleContainer>Create {numberOfCampaigns} New Campaigns</ModalTitleContainer>
      <Formik
        initialValues={{
          start_date: startDate,
          topics,
          sources: [],
          media: [],
        }}
        onSubmit={(values) => onSubmit(values)}
      >
        {({ submitForm, isSubmitting, values }) => (
          <Form className={Styles.form}>
            <StartDateField />
            <TopicsField numberOfCampaigns={numberOfCampaigns} />
            <SourcesField name="sources" />
            <MediaField name="media" topic={values.topics[0]} />
            <ModalSubmitContainer>
              <Button size="lg" onPress={() => submitForm()} isDisabled={isSubmitting}>
                Analyze
              </Button>
            </ModalSubmitContainer>
          </Form>
        )}
      </Formik>
    </>
  )
}
